import getEnvironment from '../../util/environment';

// These keys go in the HTML, so it's not secret
const PRODUCTION_WRITE_KEY = 'FNVX8mJr5XOhm3eDlo59v0MeXIzmQC5C';
const STAGING_WRITE_KEY = '4h4y7mlgqb';

export const SEGMENT_WRITE_KEY = getEnvironment() === 'production' ? PRODUCTION_WRITE_KEY : STAGING_WRITE_KEY;

export const EVENTS = {
  TURN_OFF_NEW_NAV: 'core__nav_bar__turn_off__new_navigation',
  TURN_ON_NEW_NAV: 'core__nav_bar__turn_on__new_navigation',
  OPEN_WHATS_NEW_MODAL: 'core__nav_bar__opened__whats_new_modal'
};
